import React, { createContext, useContext, useEffect } from "react";
import { Form,  Typography, Select, notification } from "antd";
import MonthlysettingStore from "../store/monthlysettingstore";
import wrfmSettingStore from "../store/wrfmsettingstore";
import { observer } from "mobx-react-lite";
const _ = require("underscore");
const monthlySettingStoreCtx = createContext(MonthlysettingStore);
const { Title } = Typography;
const { Option } = Select;
export const Level = observer(() => {
  const monthlySettingStore = useContext(monthlySettingStoreCtx);

  useEffect(() => {
    async function loadLevels() {
      try {
         await wrfmSettingStore.loadLevels();
      } catch (error) {
         notification.error({
          message: "SPARS Feedback",
          description: `download failed,${error.message}`,
        });
      }
     
    }
    loadLevels();
  }, []);
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <h3>Hierarchy ID:</h3>
          <Title
            level={4}
            style={{
              display: "inline-block",
              marginLeft: "5px",
              fontSize: "16px",
              marginTop: "5px",
              color: "#3e4095",
            }}
          >
            {` ${monthlySettingStore.selField.split(" ").join("_")}_${
              monthlySettingStore.selWell
            }_${monthlySettingStore.selLevel ?? ""}`}
          </Title>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Form.Item label="Level" required>
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select well level(string)"
              optionFilterProp="children"
              value={monthlySettingStore.selLevelId}
              onChange={(value, selItem) => {
                try {
                  monthlySettingStore.selLevelId = value;
                  monthlySettingStore.selLevel = selItem.children;
                } catch (error) {
                  notification.error({
                    message: "SPARS Feedback",
                    description: `level loading failed`,
                  });
                }

                // console.log(value)
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {[...wrfmSettingStore.levels.values()].map((l) => (
                <Option value={l.levelId} key={l.levelId}>
                  {l.levelName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      </div>
    </div>
  );
});

